export default "__VITE_ASSET__ClpcADj4__"